module.exports = __webpack_public_path__ + "static/img/networkAnomali.374f5340.png";